import { render, staticRenderFns } from "./TButton.vue?vue&type=template&id=55b51b44&scoped=true&"
import script from "./TButton.vue?vue&type=script&lang=js&"
export * from "./TButton.vue?vue&type=script&lang=js&"
import style0 from "./TButton.vue?vue&type=style&index=0&id=55b51b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b51b44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b51b44')) {
      api.createRecord('55b51b44', component.options)
    } else {
      api.reload('55b51b44', component.options)
    }
    module.hot.accept("./TButton.vue?vue&type=template&id=55b51b44&scoped=true&", function () {
      api.rerender('55b51b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/TButton.vue"
export default component.exports